const KEY = 'admination.azav.kohorte.coachings'
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/

export function getKohorte(): string | null {
  const stored = localStorage.getItem(KEY)
  return stored !== null && ISO_DATE.test(stored) ? stored : null
}

export function setKohorte(beginn: string | null): void {
  if (beginn === null) localStorage.removeItem(KEY)
  else localStorage.setItem(KEY, beginn)
}
